import { create } from 'zustand'

type ProjectsState = {
  hoveredProjectId: number | null
  setHoveredProjectId: (hoveredProjectId: number | null) => void
  selectedProjectId: number | null
  setSelectedProjectId: (selectedProjectId: number | null) => void
}

export const useProjectsStore = create<ProjectsState>(set => ({
  hoveredProjectId: null,
  selectedProjectId: null,

  setHoveredProjectId: hoveredProjectId => set(() => ({ hoveredProjectId })),
  setSelectedProjectId: selectedProjectId => set(() => ({ selectedProjectId })),
}))
